import { assign } from "xstate";

import cloneDeep from "lodash/cloneDeep";

const toggleSidebar = assign({
  showSidebar: function ({ event, context, self }) {
    return !context.showSidebar;
  },
});
const toggleMenu = assign({
  showMenu: function ({ event, context, self }) {
    return !context.showMenu;
  },
});
const resetAR = (_) => {};

const hideSectionTitle = assign({
  showSectionTitle: false,
});
const hideDisclaimer = assign({
  hideDisclaimer: true,
});
const showDisclaimer = assign({
  hideDisclaimer: false,
});
const showSectionTitle = assign({
  showSectionTitle: true,
});
const setStarted = assign({
  started: function ({ event, context, self }) {
    return true;
  },
});
const setOverrideTitle = assign({
  overrideTitle: function ({ event, context, self }, params) {
    return params.title;
  },
});
const setPreviousState = assign({
  prevState: function ({ event, context, self }, params) {
    return self.getSnapshot().value;
  },
});
const actions = {
  hideDisclaimer,
  showDisclaimer,
  toggleSidebar,
  toggleMenu,
  hideSectionTitle,
  showSectionTitle,
  setStarted,
  setOverrideTitle,
  setPreviousState,
};
export default actions;
